import { render } from "./ImageSlider.vue?vue&type=template&id=07e1b492&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"

import "./ImageSlider.vue?vue&type=style&index=0&id=07e1b492&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e1b492"]])

export default __exports__